var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-toast',{attrs:{"auto-hide-delay":_vm.autoHideDelay,"no-auto-hide":_vm.noAutoHide,"no-close-button":_vm.noCloseButton,"solid":_vm.solid,"title":_vm.title,"toaster":_vm.toaster,"variant":_vm.color,"visible":_vm.value},on:{"change":function($event){return _vm.$emit('input', $event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }